
const MINIMUM_PHONE_LENGTH = 5;
const MAXIMUM_PHONE_LENGTH_DEFAULT = 10;
const MAXIMUM_PHONE_LENGTH_GERMANY = 11;
const FRENCH_COUNTRY_PREFIX = '33';

const COUNTRY_CODES = {
    fr: '0033',
};

export function isValidPhone(phoneNumber, countryCode = 'fr') {
    if (!phoneNumber) return false;

    const cleanNumber = phoneNumber.replace(/\D/g, '');

    if (cleanNumber.length < MINIMUM_PHONE_LENGTH) return false;

    if (countryCode.toLowerCase() === 'de') {
        return cleanNumber.length <= MAXIMUM_PHONE_LENGTH_GERMANY;
    }

    return cleanNumber.length <= MAXIMUM_PHONE_LENGTH_DEFAULT;
}

export function formatPhoneForMatch(phoneNumber, countryCode = 'fr') {
    if (!phoneNumber) return { numero: '', indicatif: '' };

    let cleanNumber = phoneNumber.replace(/\D/g, '');

    // Remove French country prefix if present
    if (cleanNumber.startsWith(FRENCH_COUNTRY_PREFIX)) {
        cleanNumber = cleanNumber.slice(2);
    }

    return {
        numero: cleanNumber,
        indicatif: COUNTRY_CODES[countryCode.toLowerCase()] || ''
    };
}